import { UAnimatedIcon, animatedIconUrl } from '@simOn/ui/sim-animated-icons';

export type BaseSimIconType =
  | 'accelerometer_sensor'
  | 'account_dark'
  | 'account_light'
  | 'poi_location'
  | 'add'
  | 'alarm'
  | 'notifications'
  | 'adding_card'
  | 'measure_tool'
  | 'door_open'
  | 'error_outline'
  | 'add-photo'
  | 'magic_pen'
  | 'arrow_down'
  | 'asset'
  | 'add_location_alt'
  | 'asset_placemarker'
  | 'flood_sensor_alarm'
  | 'asset_add'
  | 'back'
  | 'back_new'
  | 'bulb_on'
  | 'list'
  | 'calendar'
  | 'calendar_today'
  | 'calendar_blank'
  | 'co_sensor'
  | 'cancel'
  | 'carousel-left-slider'
  | 'carousel-right-slider'
  | 'edit_location'
  | 'edit_base'
  | 'exit_to_app'
  | 'expand_less'
  | 'expand_more'
  | 'thermometer_green'
  | 'motion_sensor_detected'
  | 'humidity'
  | 'play_scene'
  | 'rgb_on'
  | 'roller_shutter_100'
  | 'smoke_sensor_alarm'
  | 'thermostat'
  | 'seismic_sensor'
  | 'chat'
  | 'gas_detector'
  | 'tag'
  | 'heat_sensor_alarm'
  | 'check_plans'
  | 'check_outline'
  | 'check_table'
  | 'close' // close icon with border
  | 'close2' // close icon without border
  | 'close3' // close icon without border
  | 'comment'
  | 'clock'
  | 'collections'
  | 'copy'
  | 'compare_arrows'
  | 'currency'
  | 'delete'
  | 'device'
  | 'device_settings'
  | 'documents'
  | 'documents_file_doc'
  | 'documents_file_pdf'
  | 'documents_file_tiff'
  | 'documents_file_upload'
  | 'documents_file_xls'
  | 'laundry_on'
  | 'dollar'
  | 'dot-green'
  | 'dot-red'
  | 'down'
  | 'download'
  | 'edit'
  | 'euro'
  | 'events'
  | 'event_repeat'
  | 'exit'
  | 'fullscreen_exit_dark'
  | 'fullscreen_exit_light'
  | 'fullscreen'
  | 'note_unresolved'
  | 'note_resolved'
  | 'note_pending'
  | 'note_info'
  | 'note_inprogress'
  | 'fullscreen_dark'
  | 'fullscreen_light'
  | 'hamburger'
  | 'info'
  | 'line'
  | 'lock_open'
  | 'lock_closed'
  | 'lock'
  | 'lock_person'
  | 'mail'
  | 'phone'
  | 'more'
  | 'next'
  | 'no_recurring_event'
  | 'personal_details'
  | 'person'
  | 'person_add_alt'
  | 'envelope'
  | 'sync'
  | 'photo'
  | 'pin'
  | 'play'
  | 'plus'
  | 'people_alt'
  | 'position_marker'
  | 'position_add'
  | 'position_edit'
  | 'position_redo'
  | 'drag_dots'
  | 'recurring_event'
  | 'refresh'
  | 'search'
  | 'send'
  | 'scene'
  | 'scenes'
  | 'sub-error'
  | 'up'
  | 'recurring'
  | 'video'
  | 'ornaments'
  | 'construction'
  | 'finishingmats'
  | 'equipment'
  | 'art'
  | 'plants'
  | 'hobby'
  | 'electric'
  | 'furniture'
  | 'pipes'
  | 'sockets'
  | 'security'
  | 'hvac'
  | 'homeappliances'
  | 'entertainment'
  | 'meters'
  | 'blinds'
  | 'sensors'
  | 'garden'
  | 'other'
  | 'assetOtherIcon'
  | 'activity_log'
  | 'connections'
  | 'general_info'
  | 'import_device'
  | 'role_templates'
  | 'rooms'
  | 'tickets'
  | 'users'
  | 'device_list'
  | 'disabled_element'
  | 'model_browser'
  | 'settings'
  | 'hide'
  | 'history_log'
  | 'location_on'
  | 'show'
  | 'dont_show'
  | 'layout_manager'
  | 'layout_manager_outline'
  | 'light_bulb'
  | 'image'
  | 'flag'
  | 'flag_check'
  | 'lights'
  | 'cross_overlay'
  | 'place'
  | 'admin_panel_settings'
  | 'add_room_position'
  | 'room_position'
  | 'cloud'
  | 'refresh_stroke'
  | 'private_link'
  | 'pin_stroke'
  | 'error_disconnected'
  | 'replay'
  | 'error_provider_unauthorized'
  | 'item_locked'
  | 'error_home_center'
  | 'delay'
  | 'trigger'
  | 'manual'
  | 'device2'
  // scene
  | 'sceneOff'
  | 'sceneBlock'
  | 'sceneDrop'
  | 'sceneHouseLocked'
  | 'sceneHouseUnlocked'
  | 'sceneGarage'
  | 'sceneClosedDoor'
  | 'sceneOpenDoor'
  | 'sceneDay'
  | 'sceneDaySecond'
  | 'sceneNight'
  | 'sceneNightSecond'
  | 'sceneSunrise'
  | 'sceneSunset'
  | 'sceneTemperature'
  | 'sceneVentilation'
  | 'sceneLighting'
  | 'sceneSaveLight'
  | 'sceneSaveMoney'
  | 'sceneOutdoorLight'
  | 'sceneNature'
  | 'sceneSolarPanels'
  | 'sceneSaveBattery'
  | 'sceneSaveEnergy'
  | 'sceneSaveWater'
  | 'sceneMeal'
  | 'sceneMusic'
  | 'sceneBedroom'
  | 'sceneDiningRoom'
  | 'sceneGarden'
  | 'sceneKitchen'
  | 'sceneLibrary'
  | 'sceneLivingRoom'
  | 'arrow_outward'
  | 'repeat'
  | 'sceneOfficeFirst'
  | 'sceneOfficeSecond'
  | 'sceneHomeCinema'
  | 'sceneStereo'
  | 'star_filled'
  | 'star'
  | 'holiday_village'
  | 'movie'
  | 'upload_file'
  | 'sceneVanityTable'
  | 'weather_clear_day'
  | 'weather_scattered_clouds'
  | 'weather_few_clouds'
  | 'weather_broken_clouds'
  | 'weather_shover_rain'
  | 'weather_thunder'
  | 'weather_snow'
  | 'weather_mist'
  | 'full_arrow_up'
  | 'users_online'
  | 'upload'
  | 'link'
  | 'event'
  | 'insert_drive_file'
  | 'pencil'
  | 'full_arrow_down'
  | 'arrow_upward'
  | 'arrow_downward'
  | 'check'
  | 'block'
  | 'email'
  | 'keyboard_double_arrow_left'
  | 'keyboard_double_arrow_right'
  | 'home'
  | 'view_in_ar'
  | 'settings_remote'
  | 'folder_open'
  | 'apps'
  | 'icon_folder_info'
  | 'add_folder_illustration'
  | 'folder_illustration'
  | 'format_paint'
  | 'settings_filled'
  | 'chair'
  | 'folder'
  | 'folder_fill'
  | 'grid'
  | 'hub'
  | 'keyboard_arrow_left'
  | 'keyboard_arrow_right'
  | 'union'
  | 'meeting_room'
  | 'add_location'
  | 'comments_disabled'
  | 'start'
  | 'comments'
  | 'task'
  | 'task_alt'
  | 'images'
  | 'image_not_supported'
  | 'list_alt'
  | 'assignment'
  | 'content_paste_go'
  | 'drive_file'
  | 'drive_file_rename_outline'
  | 'drive_file_move'
  | 'open_in_new'
  | 'filter_list'
  | 'door_front'
  | 'multimedia'
  | 'homeAppliances'
  | 'officeEquipment'
  | 'decoration'
  | 'lightingSystems'
  | 'electrical'
  | 'fireSafety'
  | 'plumbing'
  | 'sanitaryAndHygiene'
  | 'hvacSystems'
  | 'res'
  | 'transport'
  | 'education'
  | 'tools'
  | 'machines'
  | 'spareParts'
  | 'pets'
  | 'kids'
  | 'finishingMaterials'
  | 'empty_state'
  | 'empty_state_task'
  | 'empty_state_task_no_add'
  | 'empty_state_checklist'
  | 'empty_state_checklist_no_add'
  | 'empty_state_scan'
  | 'empty_table_state_image'
  | 'empty_table_state_image_no_add'
  | 'empty_state_contractors'
  | 'empty_state_contractors_no_add'
  | 'empty_state_event'
  | 'empty_state_event_no_add'
  | 'description'
  | 'checklist_rtl'
  | 'category_other'
  | 'category_multimedia'
  | 'category_home_appliances'
  | 'category_office_equipment'
  | 'category_furniture'
  | 'category_decoration'
  | 'category_lighting_systems'
  | 'category_electrical'
  | 'category_plumbing'
  | 'category_construction'
  | 'category_finishing_materials'
  | 'category_tools'
  | 'category_hammer'
  | 'category_plants'
  | 'category_garden'
  | 'category_cctv'
  | 'category_wifi'
  | 'category_fingerprints'
  | 'category_security'
  | 'category_fire_safety'
  | 'category_sanitary_and_hygiene'
  | 'category_medical'
  | 'category_wallet_key'
  | 'category_unlock'
  | 'category_cube_arrow'
  | 'category_wind_turbine'
  | 'category_machines'
  | 'category_spare_parts'
  | 'category_res'
  | 'category_hvac_systems_a'
  | 'category_hvac_systems_b'
  | 'category_hvac_systems_c'
  | 'category_gauge'
  | 'category_thermometer'
  | 'category_network'
  | 'category_electronics'
  | 'category_circuit'
  | 'category_transport'
  | 'category_transport_mix'
  | 'category_transport_tram'
  | 'category_transport_bus'
  | 'category_transport_truck'
  | 'category_transport_plane'
  | 'category_first_aid'
  | 'category_parking'
  | 'category_accessible'
  | 'category_exit'
  | 'category_elevator'
  | 'category_escalator_up'
  | 'category_escalator_down'
  | 'category_stairs_up'
  | 'category_stairs_down'
  | 'category_book'
  | 'category_hobby'
  | 'category_film_reel'
  | 'category_music_note'
  | 'category_gaming_pad'
  | 'category_camera'
  | 'category_images'
  | 'category_pets'
  | 'category_kids'
  | 'category_education'
  | 'category_briefcase'
  | 'category_contact_page'
  | 'category_documents'
  | 'category_invoice_cube'
  | 'category_analytics_doc'
  | 'category_analytics_chart'
  | 'category_flask_a'
  | 'category_flask_b'
  | 'category_test_tubes'
  | 'category_microscope'
  | 'category_virus'
  | 'category_atom'
  | 'category_orbit'
  | 'category_chemistry_formula'
  | 'category_cutlery'
  | 'category_mug'
  | 'category_bowl'
  | 'category_hot_soup'
  | 'category_glass_wine'
  | 'category_organic_food'
  | 'category_healthy_food'
  | 'category_fastfood';

export type SimIconType = BaseSimIconType | UAnimatedIcon;
export interface SimIconDataInterface {
  url: string;
  icon: {
    [key in BaseSimIconType]: string;
  };
}

export const SIM_ICON_DATA: SimIconDataInterface = {
  url: 'assets/simon-theme/icons/',
  icon: {
    images: 'images.svg',
    image_not_supported: 'image_not_supported.svg',
    comments: 'comments.svg',
    measure_tool: 'measure_tool.svg',
    layout_manager_outline: 'layout_manager_outline.svg',
    upload: 'upload.svg',
    task: 'task.svg',
    task_alt: 'task_alt.svg',
    start: 'start.svg',
    arrow_downward: 'arrow_downward.svg',
    check: 'check.svg',
    checklist_rtl: 'checklist_rtl.svg',
    block: 'block.svg',
    arrow_upward: 'arrow_upward.svg',
    list: 'list.svg',
    drive_file_move: 'drive_file_move.svg',
    list_alt: 'list_alt.svg',
    admin_panel_settings: 'admin_panel_settings.svg',
    assignment: 'assignment.svg',
    content_paste_go: 'content_paste_go.svg',
    check_outline: 'check_outline.svg',
    error_outline: 'error_outline.svg',
    sync: 'sync.svg',
    envelope: 'envelope.svg',
    person: 'person.svg',
    person_add_alt: 'person_add_alt.svg',
    account_dark: 'account_HEAD_dark.svg',
    account_light: 'account_HEAD_light.svg',
    location_on: 'location_on.svg',
    link: 'link.svg',
    event: 'event.svg',
    event_repeat: 'event_repeat.svg',
    insert_drive_file: 'insert_drive_file.svg',
    image: 'image.svg',
    add: 'add.svg',
    'add-photo': 'add photo.svg',
    asset: 'asset.svg',
    asset_placemarker: 'asset_placemarker.svg',
    asset_add: 'asset_add.svg',
    add_location_alt: 'add_location_alt.svg',
    back: 'arrow_Back.svg',
    movie: 'movie.svg',
    back_new: 'arrow_back_2.svg',
    calendar: 'calendar.svg',
    calendar_today: 'calendar_today.svg',
    calendar_blank: 'calendar_blank.svg',
    'carousel-left-slider': 'carousel-left-slider.svg',
    'carousel-right-slider': 'carousel-right-slider.svg',
    chat: 'chat.svg',
    close: 'close.svg',
    close2: 'close2.svg',
    close3: 'close3.svg',
    comment: 'comment.svg',
    clock: 'clock.svg',
    collections: 'collections_bookmark.svg',
    copy: 'content_copy.svg',
    compare_arrows: 'compare_arrows.svg',
    tag: 'tag.svg',
    delete: 'delete.svg',
    upload_file: 'upload_file.svg',
    device: 'device.svg',
    device_settings: 'device_settings.svg',
    documents: 'documents.svg',
    documents_file_doc: 'documents_file_doc.svg',
    documents_file_pdf: 'documents_file_pdf.svg',
    documents_file_tiff: 'documents_file_tiff.svg',
    documents_file_upload: 'documents_file_upload.svg',
    documents_file_xls: 'documents_file_xls.svg',
    light_bulb: 'light_bulb.svg',
    'dot-green': 'dot_green.svg',
    'dot-red': 'dot_red.svg',
    down: 'arrow_down.svg',
    expand_less: 'expand_less.svg',
    expand_more: 'expand_more.svg',
    edit: 'icon_edit_first.svg',
    drive_file: 'drive_file.svg',
    drive_file_rename_outline: 'drive_file_rename_outline.svg',
    events: 'events.svg',
    exit: 'exit.svg',
    note_info: 'note_info.svg',
    note_inprogress: 'note_inprogress.svg',
    note_pending: 'note_pending.svg',
    note_resolved: 'note_resolved.svg',
    note_unresolved: 'note_unresolved.svg',
    fullscreen_exit_dark: 'fullscreen_exit_dark.svg',
    fullscreen_exit_light: 'fullscreen_exit_light.svg',
    fullscreen_dark: 'fullscreen_dark.svg',
    fullscreen_light: 'fullscreen_light.svg',
    fullscreen: 'fullscreen.svg',
    hamburger: 'hamburger.svg',
    history_log: 'history_log.svg',
    lock_closed: 'lock_closed.svg',
    lock_open: 'lock_open.svg',
    lock_person: 'lock_person.svg',
    more: 'more.svg',
    next: 'arrow_next.svg',
    no_recurring_event: 'no_recurring_event.svg',
    photo: 'photo.svg',
    pin: 'pin.svg',
    lock: 'lock.svg',
    play: 'play.svg',
    place: 'place.svg',
    plus: 'plus.svg',
    position_marker: 'position_marker.svg',
    position_add: 'position_add.svg',
    position_edit: 'position_edit.svg',
    private_link: 'private_link.svg',
    position_redo: 'position_redo.svg',
    recurring_event: 'recurring_event.svg',
    drag_dots: 'drag_dots.svg',
    recurring: 'recurring.svg',
    refresh: 'refresh.svg',
    scene: 'scene.svg',
    scenes: 'scenes.svg',
    search: 'search.svg',
    send: 'send.svg',
    up: 'arrow_up.svg',
    video: 'video.svg',
    adding_card: 'adding_card.svg',
    arrow_down: 'arrow_down.svg',
    cancel: 'cancel.svg',
    check_plans: 'check_plans.svg',
    check_table: 'check_table.svg',
    currency: 'currency.svg',
    dollar: 'dollar.svg',
    download: 'download.svg',
    'sub-error': 'sub-error.svg',
    euro: 'euro.svg',
    info: 'info.svg',
    line: 'line.svg',
    mail: 'mail.svg',
    phone: 'phone.svg',
    personal_details: 'personal_details.svg',
    disabled_element: 'disabled_element.svg',
    ornaments: 'ornaments.svg',
    construction: 'construction.svg',
    finishingmats: 'finishingmats.svg',
    equipment: 'equipment.svg',
    art: 'art.svg',
    plants: 'plants.svg',
    hobby: 'hobby.svg',
    electric: 'electric.svg',
    furniture: 'furniture.svg',
    other: 'other.svg',
    pipes: 'pipes.svg',
    lights: 'lights.svg',
    sockets: 'sockets.svg',
    security: 'security.svg',
    hvac: 'hvac.svg',
    homeappliances: 'homeappliances.svg',
    entertainment: 'entertainment.svg',
    meters: 'meters.svg',
    blinds: 'blinds.svg',
    sensors: 'sensors.svg',
    garden: 'garden.svg',
    assetOtherIcon: 'assetOtherIcon.svg',
    dont_show: 'dont_show.svg',
    hide: 'hide.svg',
    model_browser: 'model_browser.svg',
    settings: 'settings.svg',
    show: 'show.svg',
    layout_manager: 'layout_manager.svg',
    cross_overlay: 'cross_overlay.svg',
    activity_log: 'activity_log.svg',
    connections: 'connections.svg',
    general_info: 'general_info.svg',
    import_device: 'import_device.svg',
    role_templates: 'role_templates.svg',
    rooms: 'rooms.svg',
    tickets: 'tickets.svg',
    users: 'users.svg',
    people_alt: 'people_alt.svg',
    device_list: 'device_list.svg',
    add_room_position: 'add_room_position.svg',
    room_position: 'room_position.svg',
    cloud: 'cloud.svg',
    pin_stroke: 'pin_stroke.svg',
    refresh_stroke: 'refresh_stroke.svg',
    error_disconnected: 'error_disconnected.svg',
    error_provider_unauthorized: 'error_provider_unauthorized.svg',
    item_locked: 'item_locked.svg',
    error_home_center: 'error_home_center.svg',
    accelerometer_sensor: 'accelerometer_sensor.svg',
    alarm: 'alarm.svg',
    notifications: 'notifications.svg',
    door_open: 'door_open.svg',
    flood_sensor_alarm: 'flood_sensor_alarm.svg',
    bulb_on: 'bulb_on.svg',
    co_sensor: 'co_sensor.svg',
    thermometer_green: 'thermometer_green.svg',
    motion_sensor_detected: 'motion_sensor_detected.svg',
    humidity: 'humidity.svg',
    play_scene: 'play_scene.svg',
    rgb_on: 'rgb_on.svg',
    roller_shutter_100: 'roller_shutter_100.svg',
    smoke_sensor_alarm: 'smoke_sensor_alarm.svg',
    thermostat: 'thermostat.svg',
    seismic_sensor: 'seismic_sensor.svg',
    gas_detector: 'gas_detector.svg',
    heat_sensor_alarm: 'heat_sensor_alarm.svg',
    laundry_on: 'laundry_on.svg',
    delay: 'delay.svg',
    manual: 'manual.svg',
    trigger: 'trigger.svg',
    device2: 'device2.svg',
    // scene
    sceneOff: 'icon_scene_off.svg',
    sceneBlock: 'icon_scene_block.svg',
    sceneDrop: 'icon_scene_drop.svg',
    sceneHouseLocked: 'icon_scene_house_locked.svg',
    sceneHouseUnlocked: 'icon_scene_house_unlocked.svg',
    sceneGarage: 'icon_scene_garage.svg',
    sceneClosedDoor: 'icon_scene_closed_door.svg',
    sceneOpenDoor: 'icon_scene_open_door.svg',
    sceneDay: 'icon_scene_day.svg',
    sceneDaySecond: 'icon_scene_day_second.svg',
    sceneNight: 'icon_scene_night.svg',
    sceneNightSecond: 'icon_scene_night_second.svg',
    sceneSunrise: 'icon_scene_sunrise.svg',
    sceneSunset: 'icon_scene_sunset.svg',
    sceneTemperature: 'icon_scene_temperature.svg',
    sceneVentilation: 'icon_scene_ventilation.svg',
    sceneLighting: 'icon_scene_lighting.svg',
    sceneSaveLight: 'icon_scene_save_light.svg',
    sceneSaveMoney: 'icon_scene_save_money.svg',
    sceneOutdoorLight: 'icon_scene_outdoor_light.svg',
    sceneNature: 'icon_scene_nature.svg',
    sceneSolarPanels: 'icon_scene_solar_panels.svg',
    sceneSaveBattery: 'icon_scene_save_battery.svg',
    sceneSaveEnergy: 'icon_scene_save_energy.svg',
    sceneSaveWater: 'icon_scene_save_water.svg',
    sceneMeal: 'icon_scene_meal.svg',
    sceneMusic: 'icon_scene_music.svg',
    sceneBedroom: 'icon_scene_bedroom.svg',
    sceneDiningRoom: 'icon_scene_dining_room.svg',
    sceneGarden: 'icon_scene_garden.svg',
    sceneKitchen: 'icon_scene_kitchen.svg',
    sceneLibrary: 'icon_scene_library.svg',
    sceneLivingRoom: 'icon_scene_living_room.svg',
    sceneOfficeFirst: 'icon_scene_office_first.svg',
    sceneOfficeSecond: 'icon_scene_office_second.svg',
    sceneHomeCinema: 'icon_scene_home_cinema.svg',
    sceneStereo: 'icon_scene_stereo.svg',
    sceneVanityTable: 'icon_scene_vanity_table.svg',
    star_filled: 'star_filled.svg',
    star: 'star.svg',
    holiday_village: 'holiday_village.svg',
    weather_clear_day: '01_clear_day.svg',
    weather_few_clouds: '05_clouds.svg',
    weather_scattered_clouds: '05_clouds.svg',
    weather_broken_clouds: '06_heavy_clouds.svg',
    weather_shover_rain: '08_heavy_rain.svg',
    weather_thunder: '09_thunder.svg',
    weather_snow: '10_snow.svg',
    weather_mist: '11_fog.svg',
    full_arrow_up: 'full_arrow_up.svg',
    full_arrow_down: 'full_arrow_down.svg',
    users_online: 'users_online.svg',
    arrow_outward: 'arrow_outward.svg',
    repeat: 'repeat.svg',
    pencil: 'pencil.svg',
    email: 'email.svg',
    keyboard_double_arrow_left: 'keyboard_double_arrow_left.svg',
    keyboard_double_arrow_right: 'keyboard_double_arrow_right.svg',
    home: 'home.svg',
    view_in_ar: 'view_in_ar.svg',
    settings_remote: 'settings_remote.svg',
    folder_open: 'folder_open.svg',
    apps: 'apps.svg',
    format_paint: 'format_paint.svg',
    settings_filled: 'settings_filled.svg',
    add_location: 'add_location.svg',
    chair: 'chair.svg',
    folder: 'folder.svg',
    folder_fill: 'folder_fill.svg',
    grid: 'grid.svg',
    hub: 'hub.svg',
    magic_pen: 'magic_pen.svg',
    keyboard_arrow_left: 'keyboard_arrow_left.svg',
    keyboard_arrow_right: 'keyboard_arrow_right.svg',
    union: 'union.svg',
    meeting_room: 'meeting_room.svg',
    comments_disabled: 'comments_disabled.svg',
    poi_location: 'poi_location.svg',
    flag: 'flag.svg',
    flag_check: 'flag_check.svg',
    open_in_new: 'open_in_new.svg',
    filter_list: 'filter_list.svg',
    door_front: 'door_front.svg',
    multimedia: 'multimedia.svg',
    homeAppliances: 'homeAppliances2.svg',
    officeEquipment: 'officeEquipment.svg',
    decoration: 'decoration.svg',
    lightingSystems: 'lightingSystems.svg',
    electrical: 'electrical.svg',
    fireSafety: 'fireSafety.svg',
    plumbing: 'plumbing.svg',
    sanitaryAndHygiene: 'sanitaryAndHygiene.svg',
    hvacSystems: 'hvacSystems.svg',
    res: 'res.svg',
    transport: 'transport.svg',
    education: 'education.svg',
    tools: 'tools.svg',
    machines: 'machines.svg',
    spareParts: 'spareParts.svg',
    pets: 'pets.svg',
    kids: 'kids.svg',
    finishingMaterials: 'finishingMaterials.svg',
    description: 'description.svg',
    edit_location: 'edit_location.svg',
    edit_base: 'edit_base.svg',
    exit_to_app: 'exit_to_app.svg',
    empty_state: 'empty_state.svg',
    empty_state_task: 'empty_state_task.svg',
    empty_table_state_image_no_add: '../images/empty_table_state_image_no_add.svg',
    empty_state_task_no_add: 'empty_state_task_no_add.svg',
    empty_state_checklist: 'empty_state_checklist.svg',
    empty_state_checklist_no_add: 'empty_state_checklist_no_add.svg',
    empty_state_scan: 'empty_state_scan.svg',
    empty_table_state_image: '../images/empty_table_state_image.svg',
    empty_state_contractors: 'empty_state_contractors.svg',
    empty_state_contractors_no_add: 'empty_state_contractors_no_add.svg',
    empty_state_event: 'empty_state_event.svg',
    empty_state_event_no_add: 'empty_state_event_no_add.svg',
    icon_folder_info: 'icon_folder_info.svg',
    add_folder_illustration: 'add_folder_illustration.svg',
    folder_illustration: 'folder_illustration.svg',
    replay: 'replay.svg',
    //
    category_other: 'category_icons/other.svg',
    category_multimedia: 'category_icons/multimedia.svg',
    category_home_appliances: 'category_icons/home_appliances.svg',
    category_office_equipment: 'category_icons/office_equipment.svg',
    category_furniture: 'category_icons/furniture.svg',
    category_decoration: 'category_icons/decoration.svg',
    category_lighting_systems: 'category_icons/lighting_systems.svg',
    category_electrical: 'category_icons/electrical.svg',
    category_plumbing: 'category_icons/plumbing.svg',
    category_construction: 'category_icons/construction.svg',
    category_finishing_materials: 'category_icons/finishing_materials.svg',
    category_tools: 'category_icons/tools.svg',
    category_hammer: 'category_icons/hammer.svg',
    category_plants: 'category_icons/plants.svg',
    category_garden: 'category_icons/garden.svg',
    category_cctv: 'category_icons/cctv.svg',
    category_wifi: 'category_icons/wifi.svg',
    category_fingerprints: 'category_icons/fingerprints.svg',
    category_security: 'category_icons/security.svg',
    category_fire_safety: 'category_icons/fire_safety.svg',
    category_sanitary_and_hygiene: 'category_icons/sanitary_and_hygiene.svg',
    category_medical: 'category_icons/medical.svg',
    category_wallet_key: 'category_icons/wallet_key.svg',
    category_unlock: 'category_icons/unlock.svg',
    category_cube_arrow: 'category_icons/cube_arrow.svg',
    category_wind_turbine: 'category_icons/wind_turbine.svg',
    category_machines: 'category_icons/machines.svg',
    category_spare_parts: 'category_icons/spare_parts.svg',
    category_res: 'category_icons/res.svg',
    category_hvac_systems_a: 'category_icons/hvac_systems_a.svg',
    category_hvac_systems_b: 'category_icons/hvac_systems_b.svg',
    category_hvac_systems_c: 'category_icons/hvac_systems_c.svg',
    category_gauge: 'category_icons/gauge.svg',
    category_thermometer: 'category_icons/thermometer.svg',
    category_network: 'category_icons/network.svg',
    category_electronics: 'category_icons/electronics.svg',
    category_circuit: 'category_icons/circuit.svg',
    category_transport: 'category_icons/transport.svg',
    category_transport_mix: 'category_icons/transport_mix.svg',
    category_transport_tram: 'category_icons/transport_tram.svg',
    category_transport_bus: 'category_icons/transport_bus.svg',
    category_transport_truck: 'category_icons/transport_truck.svg',
    category_transport_plane: 'category_icons/transport_plane.svg',
    category_first_aid: 'category_icons/first_aid.svg',
    category_parking: 'category_icons/parking.svg',
    category_accessible: 'category_icons/accessible.svg',
    category_exit: 'category_icons/exit.svg',
    category_elevator: 'category_icons/elevator.svg',
    category_escalator_up: 'category_icons/escalator_up.svg',
    category_escalator_down: 'category_icons/escalator_down.svg',
    category_stairs_up: 'category_icons/stairs_up.svg',
    category_stairs_down: 'category_icons/stairs_down.svg',
    category_book: 'category_icons/book.svg',
    category_hobby: 'category_icons/hobby.svg',
    category_film_reel: 'category_icons/film_reel.svg',
    category_music_note: 'category_icons/music_note.svg',
    category_gaming_pad: 'category_icons/gaming_pad.svg',
    category_camera: 'category_icons/camera.svg',
    category_images: 'category_icons/images.svg',
    category_pets: 'category_icons/pets.svg',
    category_kids: 'category_icons/kids.svg',
    category_education: 'category_icons/education.svg',
    category_briefcase: 'category_icons/briefcase.svg',
    category_contact_page: 'category_icons/contact_page.svg',
    category_documents: 'category_icons/documents.svg',
    category_invoice_cube: 'category_icons/invoice_cube.svg',
    category_analytics_doc: 'category_icons/analytics_doc.svg',
    category_analytics_chart: 'category_icons/analytics_chart.svg',
    category_flask_a: 'category_icons/flask_a.svg',
    category_flask_b: 'category_icons/flask_b.svg',
    category_test_tubes: 'category_icons/test_tubes.svg',
    category_microscope: 'category_icons/microscope.svg',
    category_virus: 'category_icons/virus.svg',
    category_atom: 'category_icons/atom.svg',
    category_orbit: 'category_icons/orbit.svg',
    category_chemistry_formula: 'category_icons/chemistry_formula.svg',
    category_cutlery: 'category_icons/cutlery.svg',
    category_mug: 'category_icons/mug.svg',
    category_bowl: 'category_icons/bowl.svg',
    category_hot_soup: 'category_icons/hot_soup.svg',
    category_glass_wine: 'category_icons/glass_wine.svg',
    category_organic_food: 'category_icons/organic_food.svg',
    category_healthy_food: 'category_icons/healthy_food.svg',
    category_fastfood: 'category_icons/fastfood.svg'
  }
};

export type SimIconSizeType = 'tiny' | 'small' | 'medium' | 'large' | 'huge' | 'mega' | 'full-size';

export type SimIconSizeDataType = {
  [key in SimIconSizeType]: number;
};

export const SIM_ICON_SIZE_DATA: SimIconSizeDataType = {
  small: 16,
  medium: 25,
  large: 30,
  huge: 42,
  mega: 70,
  'full-size': 100,
  tiny: 10
};

export const SimIconUrl = (icon: SimIconType): string => {
  let _icon = SIM_ICON_DATA.icon[icon as BaseSimIconType];
  let _url = SIM_ICON_DATA.url;
  let url = `${_url}${_icon}`;

  if (!_icon) {
    _icon = icon;
    url = animatedIconUrl(icon as UAnimatedIcon);
  }

  return url;
};
